import { render, staticRenderFns } from "./dashboard3.vue?vue&type=template&id=52171b66&scoped=true&"
import script from "./dashboard3.vue?vue&type=script&lang=js&"
export * from "./dashboard3.vue?vue&type=script&lang=js&"
import style0 from "./dashboard3.vue?vue&type=style&index=0&id=52171b66&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52171b66",
  null
  
)

export default component.exports